import modules___ from './__/index.js'
import modules_regulars from './regulars/index.js'
import modules_rates from './rates/index.js'
import modules_invoices from './invoices/index.js'
import modules_files from './files/index.js'
import modules_agreements from './agreements/index.js'
import _actions_regular_resum from './_actions/regular/resum.js'
import _actions_get_local from './_actions/get/local.js'
import _actions_create_regular_order from './_actions/create/regular_order.js'
import _actions_create_regular_invoice from './_actions/create/regular_invoice.js'
import _actions_create_regular_edit from './_actions/create/regular_edit.js'
import _actions_create_regular_add from './_actions/create/regular_add.js'
import _actions_create_pay_regular from './_actions/create/pay_regular.js'
import _actions_create_pay_order from './_actions/create/pay_order.js'
import _actions_create_pay_edit from './_actions/create/pay_edit.js'
import _actions_create_pay_bonus from './_actions/create/pay_bonus.js'
import _actions_create_pay_add from './_actions/create/pay_add.js'
import _actions_create_page from './_actions/create/page.js'
import _actions_create_invoice_edit from './_actions/create/invoice_edit.js'
import _actions_create_invoice_add from './_actions/create/invoice_add.js'
import _actions_change_tab from './_actions/change/tab.js'
import _actions_change_Sum from './_actions/change/Sum.js'
import _actions_change_regularPaymentTypeId from './_actions/change/regularPaymentTypeId.js'
import _actions_change_RateArticleId from './_actions/change/RateArticleId.js'
import _actions_change_PaymentTypeId from './_actions/change/PaymentTypeId.js'
import _actions_change_PaymentOperationID from './_actions/change/PaymentOperationID.js'
import _actions_change_PaymentFor from './_actions/change/PaymentFor.js'
import _actions_change_PaymentDirection from './_actions/change/PaymentDirection.js'
import _actions_change_PaymentDate from './_actions/change/PaymentDate.js'
import _actions_change_PaymentAccountId from './_actions/change/PaymentAccountId.js'
import _actions_change_PartnerLegalEntityId from './_actions/change/PartnerLegalEntityId.js'
import _actions_change_NotificationsEndDate from './_actions/change/NotificationsEndDate.js'
import _actions_change_NeedToPayDate from './_actions/change/NeedToPayDate.js'
import _actions_change_NameLat from './_actions/change/NameLat.js'
import _actions_change_Name from './_actions/change/Name.js'
import _actions_change_DocumentNumber from './_actions/change/DocumentNumber.js'
import _actions_change_dayYear from './_actions/change/dayYear.js'
import _actions_change_dayWeek from './_actions/change/dayWeek.js'
import _actions_change_dayOne from './_actions/change/dayOne.js'
import _actions_change_dayMonth from './_actions/change/dayMonth.js'
import _actions_change_CurrencyId from './_actions/change/CurrencyId.js'
import _actions_change_CreatedDate from './_actions/change/CreatedDate.js'
import _actions_change_ContragentType from './_actions/change/ContragentType.js'
import _actions_change_ContragentID_select from './_actions/change/ContragentID_select.js'
import _actions_change_ContragentId_com_spec from './_actions/change/ContragentId_com_spec.js'
import _actions_change_ContragentID_com from './_actions/change/ContragentID_com.js'
import _actions_change_ContragentID from './_actions/change/ContragentID.js'
import _actions_change_Comment from './_actions/change/Comment.js'
import _actions_change_CertificateId from './_actions/change/CertificateId.js'
import _actions_change_CategoryId from './_actions/change/CategoryId.js'
import _actions_change_CashId from './_actions/change/CashId.js'
import _actions_change_AccountNumber from './_actions/change/AccountNumber.js'
import _actions_change_AccountDate from './_actions/change/AccountDate.js'
import _actions_agreement_tab from './_actions/agreement/tab.js'
import _actions_agreement_sums from './_actions/agreement/sums.js'
import _actions_agreement_sum from './_actions/agreement/sum.js'
import _actions_agreement_remove from './_actions/agreement/remove.js'
import _actions_agreement_push from './_actions/agreement/push.js'
import _actions_agreement_getCourse from './_actions/agreement/getCourse.js'
import _actions_agreement_comment from './_actions/agreement/comment.js'
import _actions_agreement_add from './_actions/agreement/add.js'
import _actions_submit from './_actions/submit.js'
import _actions_reload from './_actions/reload.js'
import _getters_options_legals from './_getters/options/legals.js'
import _getters_options_contragents from './_getters/options/contragents.js'
import _getters_loading_page from './_getters/loading/page.js'
import _getters_loading_form from './_getters/loading/form.js'
import _getters_loading_dictionary from './_getters/loading/dictionary.js'
import _getters_disabled_date_pay from './_getters/disabled/date_pay.js'
import _getters_disabled_course_pay from './_getters/disabled/course_pay.js'
import _getters_disabled_contragent_type from './_getters/disabled/contragent_type.js'
import _getters_computed_reservation from './_getters/computed/reservation.js'
import _getters_computed_operationType from './_getters/computed/operationType.js'
import _getters_computed_hiddenOperator from './_getters/computed/hiddenOperator.js'
import _getters_computed_hiddenClient from './_getters/computed/hiddenClient.js'
import _getters_computed_allow from './_getters/computed/allow.js'
import _getters_pay_edit from './_getters/pay_edit.js'
import _getters_data from './_getters/data.js'
import _mutations_set_system from './_mutations/set/system.js'
import _mutations_set_load from './_mutations/set/load.js'
import _mutations_set_form from './_mutations/set/form.js'
import _mutations_set_agreement from './_mutations/set/agreement.js'
import _mutations_reload from './_mutations/reload.js'
import state from './_state/index.js'

export default {
    namespaced: true,
    state,
    mutations:{
        reload: _mutations_reload,
        set_agreement: _mutations_set_agreement,
        set_form: _mutations_set_form,
        set_load: _mutations_set_load,
        set_system: _mutations_set_system,
    },
    getters:{
        data: _getters_data,
        pay_edit: _getters_pay_edit,
        computed_allow: _getters_computed_allow,
        computed_hiddenClient: _getters_computed_hiddenClient,
        computed_hiddenOperator: _getters_computed_hiddenOperator,
        computed_operationType: _getters_computed_operationType,
        computed_reservation: _getters_computed_reservation,
        disabled_contragent_type: _getters_disabled_contragent_type,
        disabled_course_pay: _getters_disabled_course_pay,
        disabled_date_pay: _getters_disabled_date_pay,
        loading_dictionary: _getters_loading_dictionary,
        loading_form: _getters_loading_form,
        loading_page: _getters_loading_page,
        options_contragents: _getters_options_contragents,
        options_legals: _getters_options_legals,
    },
    actions:{
        reload: _actions_reload,
        submit: _actions_submit,
        agreement_add: _actions_agreement_add,
        agreement_comment: _actions_agreement_comment,
        agreement_getCourse: _actions_agreement_getCourse,
        agreement_push: _actions_agreement_push,
        agreement_remove: _actions_agreement_remove,
        agreement_sum: _actions_agreement_sum,
        agreement_sums: _actions_agreement_sums,
        agreement_tab: _actions_agreement_tab,
        change_AccountDate: _actions_change_AccountDate,
        change_AccountNumber: _actions_change_AccountNumber,
        change_CashId: _actions_change_CashId,
        change_CategoryId: _actions_change_CategoryId,
        change_CertificateId: _actions_change_CertificateId,
        change_Comment: _actions_change_Comment,
        change_ContragentID: _actions_change_ContragentID,
        change_ContragentID_com: _actions_change_ContragentID_com,
        change_ContragentId_com_spec: _actions_change_ContragentId_com_spec,
        change_ContragentID_select: _actions_change_ContragentID_select,
        change_ContragentType: _actions_change_ContragentType,
        change_CreatedDate: _actions_change_CreatedDate,
        change_CurrencyId: _actions_change_CurrencyId,
        change_dayMonth: _actions_change_dayMonth,
        change_dayOne: _actions_change_dayOne,
        change_dayWeek: _actions_change_dayWeek,
        change_dayYear: _actions_change_dayYear,
        change_DocumentNumber: _actions_change_DocumentNumber,
        change_Name: _actions_change_Name,
        change_NameLat: _actions_change_NameLat,
        change_NeedToPayDate: _actions_change_NeedToPayDate,
        change_NotificationsEndDate: _actions_change_NotificationsEndDate,
        change_PartnerLegalEntityId: _actions_change_PartnerLegalEntityId,
        change_PaymentAccountId: _actions_change_PaymentAccountId,
        change_PaymentDate: _actions_change_PaymentDate,
        change_PaymentDirection: _actions_change_PaymentDirection,
        change_PaymentFor: _actions_change_PaymentFor,
        change_PaymentOperationID: _actions_change_PaymentOperationID,
        change_PaymentTypeId: _actions_change_PaymentTypeId,
        change_RateArticleId: _actions_change_RateArticleId,
        change_regularPaymentTypeId: _actions_change_regularPaymentTypeId,
        change_Sum: _actions_change_Sum,
        change_tab: _actions_change_tab,
        create_invoice_add: _actions_create_invoice_add,
        create_invoice_edit: _actions_create_invoice_edit,
        create_page: _actions_create_page,
        create_pay_add: _actions_create_pay_add,
        create_pay_bonus: _actions_create_pay_bonus,
        create_pay_edit: _actions_create_pay_edit,
        create_pay_order: _actions_create_pay_order,
        create_pay_regular: _actions_create_pay_regular,
        create_regular_add: _actions_create_regular_add,
        create_regular_edit: _actions_create_regular_edit,
        create_regular_invoice: _actions_create_regular_invoice,
        create_regular_order: _actions_create_regular_order,
        get_local: _actions_get_local,
        regular_resum: _actions_regular_resum,
    },
    modules:{
        agreements: modules_agreements,
        files: modules_files,
        invoices: modules_invoices,
        rates: modules_rates,
        regulars: modules_regulars,
        __: modules___,
    },
}